import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'la-confirm-delete-document-dialog',
    imports: [CommonModule],
    template: `
    <ng-container i18n>
      Are you sure you want to delete <strong>{{ name }}</strong> from your
      documents?</ng-container
    >
  `
})
export class ConfirmDeleteDocumentDialogComponent {
  @Input() name!: string;
}
